import { LuMapPin, LuCalendarDays, LuClock, LuMail, LuNavigation, LuSun } from "react-icons/lu";
import "../../styles/beach/beach.css"


//DONNÉES DE LA SECTION BEACH (codées en dur, à mettre à jour ici chaque saison)
const BEACH = {
  email: "vblcbeach@gmail.com",
  place: {
    //Nom utilisé par les habitants, affiché sur la page
    name: "Plage de Socoa",
    //Nom de la même plage sur Google Maps, utilisé pour le lien "Itinéraire"
    mapsName: "Plage de Ciboure",
    city: "Ciboure",
  },
  period: "Du 15 juin au 15 septembre",
  sessions: [
    { day: "Mercredi", hours: "18h30 - 20h00" },
    { day: "Samedi", hours: "10h00 - 12h00" },
  ],
  //Pour afficher une photo : déposer l'image dans public/images/beach/ et renseigner "picture" (ex. "/images/beach/mathieu_conan.jpg")
  coachs: [
    { firstName: "Mathieu", lastName: "Conan", picture: "/images/beach/MathConan.png" },
    { firstName: "Florian", lastName: "Cordelier", picture: "/images/beach/FlorianCordelier.jpg" },
  ],
  fees: [
    { label: "Adhérent VBLC", price: 20 },
    { label: "Non adhérent VBLC", price: 40 },
  ],
};

const MAP_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${BEACH.place.mapsName}, ${BEACH.place.city}`)}`;
const MAIL_LINK = `mailto:${BEACH.email}?subject=${encodeURIComponent("Inscription VBLC Beach")}`;


function Beach() {

  return (
    <main className="beach">

      {/* EN-TÊTE */}
      <header className="page-hero">
        <div className="wrap page-hero_content">
          <p className="page-hero_eyebrow">
            <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
            Beach-volley
          </p>
          <h1 className="page-hero_title">VBLC Beach</h1>
          <p className="page-hero_text">La section beach-volley du club : entraînements encadrés sur la {BEACH.place.name}, tout l’été.</p>
        </div>
      </header>

      {/* PHOTO */}
      <div className="wrap">
        <img className="beach_photo" src="/images/beach/beach_picture_hero.jpg" alt="Les joueuses et joueurs du VBLC" />
      </div>

      {/* COACHS */}
      <section className="section" aria-labelledby="coachs-title">
        <div className="wrap">
          <div className="section_header">
            <div className="section_heading">
              <p className="eyebrow beach_eyebrow">Encadrement</p>
              <h2 id="coachs-title" className="title-xl">Les coachs</h2>
            </div>
          </div>

          <ul className="beach_coachs">
            {BEACH.coachs.map((coach) => (
              <li key={coach.lastName} className="beach_coach surface">
                {coach.picture
                  ? <img className="beach_coach_picture" src={coach.picture} alt={`${coach.firstName} ${coach.lastName}`} />
                  : <span className="beach_coach_picture beach_coach_initials" aria-hidden="true">{coach.firstName[0]}{coach.lastName[0]}</span>}
                <div>
                  <p className="beach_coach_role">Coach beach-volley</p>
                  <h3 className="title-md">{coach.firstName} {coach.lastName}</h3>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* LIEU & HORAIRES */}
      <section className="section section--white" aria-labelledby="schedule-title">
        <div className="wrap beach_split">
          <div className="section_heading">
            <p className="eyebrow beach_eyebrow">Lieu &amp; horaires</p>
            <h2 id="schedule-title" className="title-xl">Rendez-vous sur le sable</h2>
            <ul className="beach_facts">
              <li>
                <span className="icon-tile icon-tile--sand" aria-hidden="true"><LuMapPin /></span>
                <div>
                  <p className="beach_fact_label">Lieu</p>
                  <p className="beach_fact_value">{BEACH.place.name}, {BEACH.place.city}</p>
                  <p className="beach_fact_note">Sur Google Maps : « {BEACH.place.mapsName} »</p>
                  <a className="link-arrow" href={MAP_LINK} target="_blank" rel="noreferrer">
                    <LuNavigation aria-hidden="true" /> Itinéraire<span className="sr-only"> (nouvel onglet)</span>
                  </a>
                </div>
              </li>
              <li>
                <span className="icon-tile icon-tile--sand" aria-hidden="true"><LuCalendarDays /></span>
                <div>
                  <p className="beach_fact_label">Période</p>
                  <p className="beach_fact_value">{BEACH.period}</p>
                </div>
              </li>
            </ul>
          </div>

          <ul className="beach_sessions">
            {BEACH.sessions.map((session) => (
              <li key={session.day} className="beach_session">
                <LuSun className="beach_session_icon" aria-hidden="true" />
                <p className="beach_session_day">{session.day}</p>
                <p className="beach_session_hours"><LuClock aria-hidden="true" />{session.hours}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* INSCRIPTION & COTISATION */}
      <section className="section" aria-labelledby="fees-title">
        <div className="wrap">
          <div className="section_header">
            <div className="section_heading">
              <p className="eyebrow beach_eyebrow">Inscription &amp; cotisation</p>
              <h2 id="fees-title" className="title-xl">Rejoindre la section beach</h2>
            </div>
          </div>

          <div className="beach_join">
            <ul className="beach_fees">
              {BEACH.fees.map((fee) => (
                <li key={fee.label} className="beach_fee surface">
                  <p className="beach_fee_label">{fee.label}</p>
                  <p className="beach_fee_price">{fee.price} €</p>
                </li>
              ))}
            </ul>

            <div className="beach_signup">
              <span className="icon-tile icon-tile--red" aria-hidden="true"><LuMail /></span>
              <h3 className="title-md">Inscription par e-mail</h3>
              <p>Pour vous inscrire, envoyez-nous simplement un e-mail.</p>
              <a className="btn btn--primary btn--lg" href={MAIL_LINK}>
                <LuMail aria-hidden="true" /> {BEACH.email}
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
};

export default Beach;
